var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5998 5.99999L0.699805 2.09999C0.516471 1.91665 0.424805 1.68332 0.424805 1.39999C0.424805 1.11665 0.516471 0.883321 0.699805 0.699988C0.883138 0.516654 1.11647 0.424988 1.3998 0.424988C1.68314 0.424988 1.91647 0.516654 2.0998 0.699988L6.6998 5.29999C6.7998 5.39999 6.87064 5.50832 6.9123 5.62499C6.95397 5.74165 6.9748 5.86665 6.9748 5.99999C6.9748 6.13332 6.95397 6.25832 6.9123 6.37499C6.87064 6.49165 6.7998 6.59999 6.6998 6.69999L2.0998 11.3C1.91647 11.4833 1.68314 11.575 1.3998 11.575C1.11647 11.575 0.883138 11.4833 0.699805 11.3C0.516471 11.1167 0.424805 10.8833 0.424805 10.6C0.424805 10.3167 0.516471 10.0833 0.699805 9.89999L4.5998 5.99999Z",
    fill: "#080E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.c57ef0395fc8158161dca3c34578e9e7.svg";
export { ForwardRef as ReactComponent };